<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-04-11 09:43:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-10 16:08:40
-->
<template>
  <div v-if="title || t">
    <div class="title" :style="{ color: color }">{{ title || t }}</div>
  </div>
</template>

<script>
export default {
  name: "GTitle",
  props: {
    title: {
      type: String,
      default: "",
    },
    t: {
      type: String,
      default: "",
    },
    border: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      defailt: () => {
        return "var(--tc);";
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.title {
  /* width: 100%; */
  position: relative;
  margin: 10px 0;
  padding: 12px 20px;
}
.title::before {
  position: absolute;
  top: 50%;
  bottom: 0;
  left: 0;
  margin-top: -15px;
  content: "";
  width: 6px;
  height: 30px;
  background-color: var(--tc);
}
</style>
